import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import PatientList from './components/PatientList';

const EditPatient = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <div className="title-general-section-icon-arrow-back">
          <h3>Listado de Pacientes</h3>
        </div>
      </Col>
    </Row>
    <Row>
      <PatientList />
    </Row>
  </Container>
);

export default EditPatient;